export default {
      id: "five-percent-usage",
      viewBox: "0 0 800 800",
      url: __webpack_public_path__ + "/gfx/iconset.13.17.6.svg#five-percent",
      toString: function () {
        return this.url;
      }
    }